<template>
    <v-container class="my-5">
      <!--  Dialogo para mostrar Detalles del Reporte   -->
      <v-dialog v-model="dialogView" scrollable max-width="700">
        <v-card class="elevation-5">
          <v-toolbar dark :color="itemDetail.status === 1 ? 'orange' : 'primary'">
            <v-toolbar-title>
              <h3>{{$t('estado')}}: {{ itemDetail.status === 1 ? $t('in_progress') : $t('done')}}</h3>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                class="align-self-end"
                color="red"
                icon
                @click="dialogView = false"
            ><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text>
            <div class="heading text-justify">
              <p>
                {{$t('comments')}}: <strong>{{itemDetail.comments}}</strong><br>
                {{$t('creation_date')}}: <strong>{{itemDetail.creation_date.split("-").reverse().join("/")}}</strong><br>
                {{$t('finish_date')}}: <strong>{{ itemDetail.finish_date !== null ? itemDetail.finish_date.split("-").reverse().join("/") : $t('in_progress')}}</strong>
              </p>
            </div>
            <v-img
                v-if="itemDetail.resident_file && extensionImage(itemDetail.resident_file) === true"
                :src="itemDetail.resident_file"
            ></v-img>
          </v-card-text>
          <v-card-actions v-show="itemDetail.status === 1" class="justify-center">
            <v-btn
                @click="newPage(itemDetail.resident_file)"
                v-if="itemDetail.resident_file && extensionImage(itemDetail.resident_file) === true"
                color="primary">
              <v-icon>mdi-file-image</v-icon>{{$t('descargar')}}
            </v-btn>
            <v-btn
                @click="newPage(itemDetail.resident_file)"
                v-else-if="itemDetail.resident_file && extensionImage(itemDetail.resident_file) === false"
                color="primary">
              <v-icon>mdi-file-pdf-box </v-icon>{{$t('descargar')}}
            </v-btn>
            <v-btn
                v-show="(itemDetail.status !== 2 & (getProfile.role === 2|| getProfile.role === 3))"
                color="gray"
                class="mr-2"
                @click="fillFields(itemDetail), update = true, dialog = true, change = false, idUpdate = itemDetail.id"
            >
              <v-icon>
                mdi-pencil
              </v-icon>
              {{$t('change')}}
            </v-btn>
            <v-btn
                v-show="getProfile.role === 1"
                color="red"
                class="mr-2"
                @click="deleteDialog = true, idNoticeDelete = itemDetail.id"
            >
              <v-icon>
                mdi-delete
              </v-icon>
              {{$t('delete')}}
            </v-btn>
            <v-btn
                v-show="itemDetail.status === 1 && getProfile.role === 1"
                class="ma-2"
                :color="itemDetail.status === 1 ? 'primary' : ''"
                label
                @click="idUpdate = itemDetail.id, changeFinish = false, comments_manager = '', finishDialog = true"
                text-color="black"
            > <v-icon>
                mdi-check
              </v-icon>
              Marcar como Hecho
            </v-btn>
          </v-card-actions>
          <v-card-actions v-show="itemDetail.status === 2">
            <v-btn
                color="primary"
                text
            >
              {{$t('evidence')}}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                icon
                @click="show = !show"
            >
              <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>
          <v-card-text>
            <v-expand-transition v-show="itemDetail.status === 2">
              <div v-show="show">
                <v-divider></v-divider>
                <div>
                  <h4>{{$t('administrator_comments')}}: </h4>
                  <p>{{(itemDetail.comments_manager === null || itemDetail.comments_manager === '') ? $t('no_comment') : itemDetail.comments_manager}}</p>
                </div>
                <div v-if="itemDetail.administrator_file && extensionImage(itemDetail.administrator_file) === true">
                  <v-img
                      :src="itemDetail.administrator_file"
                  ></v-img>
                </div>
                <div v-else>
                  <h4>{{$t('no_vidence')}}</h4>
                </div>
              </div>
            </v-expand-transition>
          </v-card-text>
        </v-card>
      </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Reporte     -->
        <v-dialog v-model="deleteDialog" max-width="350">
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_report')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            :loading="loading"
                            color="primary"
                            @click="deleteNotice()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="finishDialog" max-width="350">
          <v-card class="elevation-5">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                {{$t('evidence')}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="clear(), finishDialog = false"
              ><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <div class="text-justify">
                {{$t('msg_evidence')}}
              </div>
              <v-checkbox
                  v-model="changeFinish"
                  name="changeFinish"
                  :label="$t('agregar') + ' '+ $t('file')"
              ></v-checkbox>
              <v-file-input
                  v-model="administrator_file"
                  :disabled="!changeFinish"
                  :rules="rules"
                  outlined
                  accept="image/png, image/jpeg"
                  placeholder="image"
                  prepend-icon="mdi-paperclip"
                  @change="oversized_function2"
                  :error-messages="errores.administrator_file"
                  :label="$t('file')"
              ></v-file-input>
              <v-textarea
                  v-model="comments_manager"
                  name="comments_manager"
                  counter
                  outlined
                  maxlength="300"
                  prepend-icon="mdi-comment-edit"
                  :label="$t('comments')"
                  :error-messages="errores.comments_manager"
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="clear(), finishDialog = false">{{$t('cerrar')}}</v-btn>
              <v-spacer/>
              <v-btn :loading="loading" :disabled="oversized" color="primary" @click="updateStatusReport">{{$t('aceptar')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{$t('Reports')}}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="450">
                <template v-slot:activator="{ on }">
                    <v-layout row wrap class="justify-center">
                        <v-btn
                                v-if="(getProfile.role === 2 || getProfile.role === 3)"
                                color="primary"
                                v-on="on"
                                @click="change = false, update = false, cleanFields()"
                        >
                            + {{$t('add_report')}}
                        </v-btn>
                    </v-layout>
                </template>
                <v-form
                        @submit.prevent="update
                            ? updateReport(idUpdate)
                            : addReport()"
                >
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('Reports')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false"
                            ><v-icon>mdi-close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-autocomplete
                                    v-model="idTypeReport"
                                    prepend-icon="mdi-alert"
                                    name="idTypeReport"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('type_reports')"
                                    :placeholder="$t('choose_category')"
                                    :error-messages="errores.idTypeReport"
                                    :items="typeReports"
                                    no-data-text="Ningún Resultado"
                                    outlined
                                    clearable
                                    autocomplete="off"
                            >
                            </v-autocomplete>
                            <v-textarea
                                    v-model="comments"
                                    name="comments"
                                    counter
                                    outlined
                                    maxlength="300"
                                    prepend-icon="mdi-comment-edit"
                                    :label="$t('comments')"
                                    :error-messages="errores.comments"
                            ></v-textarea>
                            <v-checkbox
                                    v-model="change"
                                    name="change"
                                    :label="update === false ? $t('agregar') + ' '+ $t('file') : $t('modificar') + ' '+ $t('file')"
                            ></v-checkbox>
                            <v-file-input
                                v-model="resident_file"
                                :disabled="!change"
                                :rules="rules"
                                outlined
                                accept="image/png, image/jpeg"
                                placeholder="image"
                                prepend-icon="mdi-paperclip"
                                @change="oversized_function"
                                :error-messages="errores.resident_file"
                                :label="update && resident_file !== null ? $t('file'): $t('modificar')"
                            ></v-file-input>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                            <v-spacer/>
                            <v-btn v-if="update" :disabled="oversized" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                            <v-btn v-else :loading="loading" :disabled="oversized" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
          <v-container fluid>
            <v-row dense>
              <v-col
                  v-for="report in reports"
                  :key="report.id"
                  cols="6"
              >
                <v-card @click="itemDetail = report, show = false, dialogView = true">
                  <v-img
                      v-if="report.resident_file && extensionImage(report.resident_file) === true"
                      :src="report.resident_file"
                      :aspect-ratio="16/9"
                      class="white--text align-start"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="200px"
                  >
                  </v-img>
                  <v-img
                      v-else
                      class="white--text align-start"
                      :src=" require('../../assets/alert.png')"
                      gradient="to top right, rgba(0,0,0,.7), rgba(25,32,72,.9)"
                      :aspect-ratio="16/9"
                      height="200px"
                  >
                  </v-img>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" xs="12" sm="6" class="text-start">
                        <v-chip
                            medium
                            class="ma-2"
                            color="blue"
                            label
                            text-color="white"
                        >
                          <v-icon left>
                            mdi-label
                          </v-icon>
                          {{ report.report_type_name}}
                        </v-chip>
                      </v-col>
                      <v-col cols="12" xs="12" sm="6" class="text-end">
                        <v-chip
                            medium
                            class="ma-2"
                            :color="report.status === 1 ? 'red' : 'primary'"
                            label
                            text-color="white"
                        >
                          {{$t('estado')}}: {{ report.status === 1 ? $t('in_progress') : $t('done')}}
                        </v-chip>
                      </v-col>
                    </v-row>
                    <div class=" font-weight-regular">
                      <strong>{{report.comments}}</strong><br>
                      {{$t('creation_date')}}: <strong>{{report.creation_date.split("-").reverse().join("/")}}</strong><br>
                      {{$t('finish_date')}}: <strong>{{ report.finish_date !== null ? report.finish_date.split("-").reverse().join("/") : $t('in_progress')}}</strong>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'reports',
  created () {
    this.getTypeReports()
    this.getReports()
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language'])
  },
  data: () => ({
    dialog: false,
    finishDialog: false,
    idTypeReport: '',
    typeReports: [],
    comments: '',
    comments_manager: '',
    commentsAux: '',
    loadingDataReports: false,
    loading: false,
    reports: [],
    errores: [],
    idUpdate: 0,
    idNoticeDelete: 0,
    deleteDialog: false,
    resident_file: null,
    administrator_file: null,
    update: false,
    change: false,
    changeFinish: false,
    rules: [],
    oversized: false,
    dialogView: false,
    itemDetail: {
      id: '',
      creation_date: '',
      finish_date: '',
      resident_file: '',
      comments: '',
      status: -1
    },
    show: false
  }),
  beforeUpdate () {
    this.rules = [
      value => !value || value.size < 2000000 || this.$t('msg_overflow_file')
    ]
  },
  methods: {
    newPage (url) {
      window.open(url, '_blank')
    },
    oversized_function (value) {
      console.log('Valor Archivo = ', value)
      if (value !== null) {
        if (value.size > 2048 * 1024) {
          this.oversized = true
        } else {
          this.oversized = false
        }
        console.log('ERoores = ', this.errores.resident_file)
        if (this.change === true && this.errores.resident_file) {
          this.errores.resident_file = ''
        }
      } else {
        this.oversized = false
      }
    },
    oversized_function2 (value) {
      console.log('Valor Archivo = ', value)
      if (value !== null) {
        if (value.size > 2048 * 1024) {
          this.oversized = true
        } else {
          this.oversized = false
        }
        console.log('ERoores = ', this.errores.administrator_file)
        if (this.changeFinish === true && this.errores.administrator_file) {
          this.errores.administrator_file = ''
        }
      } else {
        this.oversized = false
      }
    },
    getReports () {
      this.loadingDataReports = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/report_create_get/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.reports = response.data
          this.loadingDataReports = false
        })
        .catch(error => {
          this.loadingDataReports = false
          console.log(error)
        })
    },
    getTypeReports () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/type_report_create_get/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.typeReports = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    addReport () {
      console.log('File = ', this.resident_file)
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      bodyFormData.set('idHousingUnit', this.getProfile.idHousingUnit)
      bodyFormData.set('idResident', this.getProfile.id)
      bodyFormData.set('idTypeReport', this.idTypeReport)
      if (this.comments !== '') {
        bodyFormData.set('comments', this.comments)
      }
      if (this.change === true) {
        bodyFormData.append('resident_file', this.resident_file)
      }
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/report_create_get/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_added_report'))
          this.dialog = false
          this.getReports()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    updateReport (id) {
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      if (this.comments !== this.commentsAux) {
        bodyFormData.set('comments', this.comments)
      }
      if (this.change === true) {
        bodyFormData.append('resident_file', this.resident_file)
      }
      bodyFormData.set('idTypeReport', this.idTypeReport)
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/report_get_detail_and_update_it/' + id + '/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getReports()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_report_updated'))
          this.dialog = false
          this.dialogView = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    updateStatusReport () {
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()

      bodyFormData.set('status', 2)
      bodyFormData.set('comments_manager', this.comments_manager)
      bodyFormData.set('finish_date', new Date().toISOString().substr(0, 10))
      if (this.changeFinish === true) {
        bodyFormData.append('administrator_file', this.administrator_file)
      }
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/report_get_detail_and_update_it/' + this.idUpdate + '/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getReports()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_report_updated'))
          this.finishDialog = false
          this.dialogView = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    deleteNotice () {
      this.loading = true
      const config = {
        method: 'delete',
        url: ' https://residencial-services.intrare.app/report_get_detail_and_update_it/' + this.idNoticeDelete + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        this.loading = false
        console.log('Report con ID = ', this.idNoticeDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_report_deleted'))
        this.getReports()
        setTimeout(this.clear, 3000)
        this.dialogView = false
        this.deleteDialog = false
      })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    cleanFields () {
      this.comments = ''
      this.idTypeReport = null
      this.resident_file = null
      this.oversized = false
    },
    fillFields (item) {
      if (item.resident_file !== null) {
        var fileAux = new File(['foo'], item.resident_file)
        this.resident_file = fileAux
      }
      this.comments = item.comments
      this.commentsAux = item.comments
      this.idTypeReport = item.idTypeReport
      this.oversized = false
    },
    clear: function () {
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      // this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
    },
    changeStatus () {
      console.log('changeStatus')
    },
    extensionImage (url) {
      if (url.includes('.png') || url.includes('.gif') || url.includes('.jpeg') || url.includes('.jpg')) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>

</style>
